module.exports = __webpack_public_path__ + "img/BI_4.c9536c77.png";